const baseState = {
    products: {},
};
export default function reducer(state = baseState, action) {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case 'B2B/FETCH_PRODUCTS_SUCCESS':
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { products: Object.assign(Object.assign({}, state.products), { [action.payload.region]: payload.products }) });
        case 'B2B/FETCH_PRODUCTS_FAILED':
        case 'B2B/FETCH_PRODUCTS':
        default:
            return state;
    }
}
